import { getPaletteColor } from "theme/helpers";
import { TStyles } from "utils/Styles";

const styles: TStyles = {
  content: {
    flexGrow: 1,
    height: "100vh",
    overflowX: "auto",
    backgroundColor: getPaletteColor("background.default"),
    display: "flex",
    flexDirection: "column",
  },
};

export default styles;
